import { render, staticRenderFns } from "./barraderecha.vue?vue&type=template&id=63242cb8&scoped=true&"
import script from "./barraderecha.vue?vue&type=script&lang=ts&"
export * from "./barraderecha.vue?vue&type=script&lang=ts&"
import style0 from "./barraderecha.vue?vue&type=style&index=0&id=63242cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63242cb8",
  null
  
)

export default component.exports